import appClient from "../../common/services/AppClient";
import { endpoints } from "../../../config";
import {
    WbAction,
    WbDocument,
    WbSubject,
    WbSubjectsListResponse,
    WbTask,
} from "../types/WbTypes";

export default class WorkbenchService {
    async searchSubjects(query: string) {
        const url = `${endpoints.tasksUrl}workbench/subjects?searchTerm=${encodeURIComponent(query)}&page=1&pageSize=10&includeArchived=false&sortField=identifier&sortDirection=1`;
        const response = await appClient.get<WbSubjectsListResponse>(url);
        return response;
    }

    async fetchSubject(subjectId: string) {
        const url = `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}`;
        const response = await appClient.get<WbSubject>(url);
        return response;
    }

    async fetchSubjectTasks(subjectId: string) {
        const url = `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/tasks`;
        const response = await appClient.get<WbTask[]>(url);
        return response;
    }

    async fetchSubjectDocuments(subjectId: string) {
        const url = `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/documents`;
        const response = await appClient.get<WbDocument[]>(url);
        return response;
    }

    async fetchSubjectActions(subjectId: string) {
        const url = `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/actions`;
        const response = await appClient.get<WbAction[]>(url);
        return response;
    }
}
